var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgListIconMultiColor = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--dlMultiColorPrimary)",
  d: "M16 8H5v2h11V8Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--dlMultiColorSecondary)",
  d: "M3 8H0v2h3V8Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--dlMultiColorPrimary)",
  d: "M11 12H5v2h6v-2Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--dlMultiColorSecondary)",
  d: "M3 12H0v2h3v-2Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--dlMultiColorPrimary)",
  d: "M12 4H5v2h7V4Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--dlMultiColorSecondary)",
  d: "M3 4H0v2h3V4Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--dlMultiColorPrimary)",
  d: "M16 0H5v2h11V0Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--dlMultiColorSecondary)",
  d: "M3 0H0v2h3V0Z"
})));
export default SvgListIconMultiColor;